import { createApi } from "@reduxjs/toolkit/query/react";
import customBaseQuery from "../../../utils/customBaseQuery";
import { UploadConfigPayload } from "../types/question-type";

export const SubjectiveAPI = createApi({
  reducerPath: "SubjectiveAPI",
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    createSubjectiveQuestion: builder.mutation({
      query: ({ access, type }: any) => ({
        url: `/subjective/${access}/${type}?submissiontype=${type}`,
        method: "POST"
      }),
      extraOptions: { service: "MCQ_Assessment" }
    }),
    updateSubjectiveQuestion: builder.mutation({
      query: ({ questionId, version, body }: any) => ({
        url: `/subjective/${questionId}/${version}`,
        method: "PUT",
        body: body
      }),
      extraOptions: { service: "MCQ_Assessment" }
    }),
    updateSubjectiveStatus: builder.mutation({
      query: ({ questionId, version, data }: any) => ({
        url: `/subjective/${questionId}/status/${version}`,
        method: "PUT",
        body: data
      }),
      extraOptions: { service: "MCQ_Assessment" }
    }),
    fetchRubricById: builder.query({
      query: ({ rubricId }: { rubricId: string }) => ({
        url: `/rubric/${rubricId}`,
        method: "GET"
      }),
      extraOptions: { service: "MCQ_Assessment" }
    }),
    fetchReport: builder.query({
      query: ({
        questionId,
        ongoingId,
        version
      }: {
        questionId: string;
        ongoingId: string;
        version: number;
      }) => ({
        url: `/ongoing/subjective/submission-eval/${ongoingId}/${questionId}/${version}?attemptType=latest`,
        method: "GET"
      }),
      extraOptions: { service: "Assessment" }
    }),
    subjectiveUploadConfig: builder.mutation({
      query: ({
        questionId,
        version
      }: {
        questionId: string;
        version: number | string;
      }) => ({
        url: `/subjective/upload/${questionId}/${version}`,
        method: "POST"
      }),
      extraOptions: { service: "MCQ_Assessment" }
    }),
    subjectiveUploadUpdateConfig: builder.mutation({
      query: ({
        questionId,
        version,
        payload
      }: {
        questionId: string;
        version: number | string;
        payload: UploadConfigPayload;
      }) => ({
        url: `/subjective/upload/update/${questionId}/${version}`,
        body: payload,
        method: "POST"
      }),
      extraOptions: { service: "MCQ_Assessment" }
    }),
    getSubjectiveUploadConfig: builder.query({
      query: ({
        questionId,
        version
      }: {
        questionId: string;
        version: number | string;
      }) => ({
        url: `/subjective/upload/${questionId}/${version}`,
        method: "GET"
      }),
      extraOptions: { service: "MCQ_Assessment" }
    }),
    getValidateUploadConfig: builder.query({
      query: ({
        questionId,
        version
      }: {
        questionId: string;
        version: number | string;
      }) => ({
        url: `/subjective/upload/validate/${questionId}/${version}`,
        method: "GET"
      }),
      extraOptions: { service: "MCQ_Assessment" }
    }),
    subjectiveClone: builder.mutation({
      query: ({ version, questionId }: any) => ({
        url: `/subjective/clone/${questionId}/${version}`,
        method: "POST"
      }),
      extraOptions: { service: "MCQ_Assessment" }
    }),
    getSavedVideo: builder.mutation({
      query: (body: any) => ({
        url: `/subjective/assets/upload/url`,
        method: "POST",
        body
      }),
      extraOptions: { service: "Assessment" }
    })
  })
});

export const {
  useCreateSubjectiveQuestionMutation,
  useUpdateSubjectiveQuestionMutation,
  useUpdateSubjectiveStatusMutation,
  useLazyFetchRubricByIdQuery,
  useLazyFetchReportQuery,
  useFetchReportQuery,
  useSubjectiveCloneMutation,
  useSubjectiveUploadConfigMutation,
  useSubjectiveUploadUpdateConfigMutation,
  useGetSubjectiveUploadConfigQuery,
  useLazyGetSubjectiveUploadConfigQuery,
  useLazyGetValidateUploadConfigQuery,
  useGetSavedVideoMutation
} = SubjectiveAPI;
